






























































import { Component, Vue, Prop } from 'vue-property-decorator';
import SingleText from './editors/SingleText.vue';
import MultiText from './editors/MultiText.vue';
import Radio from './editors/Radio.vue';
import File from './editors/File.vue';
import Date from './editors/Date.vue';

@Component({
    components: {
        SingleText,
        MultiText,
        File,
        Date,
        Radio,
    }
})
export default class DataRow extends Vue {
    @Prop() title?: string;
    @Prop() editor?: string;
    @Prop() value?: any;
    @Prop() options?: any;
    @Prop({ default: false }) editonly?: boolean;
    @Prop({ default: false }) realtime?: boolean;
    @Prop() editCustomAction?: any;
    editing: boolean = false;

    internal: any = 0;

    commit() {
        this.$emit('input', this.internal);
        this.editing = false;
    }

    startEdit() {
        if(this.editCustomAction !== undefined) this.editCustomAction();
        else this.editing = true;
    }
}
